import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = (houseId) => ['flat-filter', houseId];

const getFlat = async (houseId) => {
  return await request.get(
    `/Filter/house_flat_cells/${houseId}`,
    {},
    'При получении списка помещений произошла ошибка'
  );
};

const useFlatsQuery = (houseId, options = {}) =>
  useQuery(key(houseId), () => getFlat(houseId), options);

export default useFlatsQuery;
